import { render, staticRenderFns } from "./ProductSeo.vue?vue&type=template&id=d13ff418&scoped=true&"
import script from "./ProductSeo.vue?vue&type=script&lang=js&"
export * from "./ProductSeo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d13ff418",
  null
  
)

export default component.exports